import { secondsToMilliseconds } from 'date-fns';

function timestampSecondsToDateString(timestamp: number) {
    const date = new Date(secondsToMilliseconds(timestamp)).toISOString();

    return `${date.substring(0, date.length - 5)}Z`;
}

export default timestampSecondsToDateString;
